import React, { useMemo } from 'react';
import { Tooltip } from '@material-ui/core';

import Optional from '../../../utils/optional';
import { findSkuTranslation } from '../actions/customSearchActions';
import { isArray } from '../../../utils/isDefined';
import { translate } from '../../../i18n/I18nProvider';
import capitaliseFirstLetter from '../../../utils/capitaliseFirstLetter';
import { formatDateForSchedule } from '../../../utils/formatDate';
import ExclamationTriangleIcon from '../../../partials/customIcons/ExclamationTriangleIcon';

const ProductCell = ({ rowData, lang, historyView }) => {
  const haveScheduled = useMemo(() => {
    if (!isArray(rowData.all)) {
      return null;
    }
    return rowData.all.find(el => el.status === 'SCHEDULED');
  }, [rowData]);

  const isTerminationPending = rowData.status === 'TERMINATION_PENDING';
  const isOutported = rowData.status === 'OUTPORTED';
  const showTerminationIcon = isTerminationPending || isOutported;

  return !historyView ? (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {findSkuTranslation({ rowData, lang })}
      {showTerminationIcon && (
        <Tooltip
          title={
            <div>
              <div>
                {isOutported
                  ? translate('SUBSCRIPTIONS.OUTPORTING_IN_PROGRESS')
                  : translate('SUBSCRIPTIONS.TERMINATION_IN_PROGRESS')}
              </div>
              <div>
                {isOutported
                  ? `${translate(
                      'SUBSCRIPTIONS.OUTPORTING_DATE'
                    )}: ${formatDateForSchedule(rowData.subExpireDate)}`
                  : `${translate(
                      'SUBSCRIPTIONS.TERMINATION_DATE'
                    )}: ${formatDateForSchedule(rowData.subExpireDate)}`}
              </div>
            </div>
          }
        >
          <ExclamationTriangleIcon />
        </Tooltip>
      )}
      {!showTerminationIcon && haveScheduled && (
        <Tooltip
          title={Optional(haveScheduled)
            .map(el => (
              <div>
                <div>{`${capitaliseFirstLetter(
                  translate('SUBSCRIPTIONS.CURRENTLY_IN_MIGRATION')
                )} ${findSkuTranslation({
                  rowData: el,
                  lang
                })}`}</div>
                <div>{`${translate('SUBSCRIPTIONS.CHANGE_DATE')} : ${
                  el.activationDate
                }`}</div>
              </div>
            ))
            .or('')}
        >
          <ExclamationTriangleIcon />
        </Tooltip>
      )}
    </div>
  ) : (
    findSkuTranslation({ rowData, lang })
  );
};

export default ProductCell;
